module.exports = {"120113001":"果园新村街道","120113002":"集贤里街道","120113003":"普东街道","120113004":"瑞景街道","120113005":"佳荣里街道","120113006":"青源街道","120113007":"广源街道","120113008":"双环邨街道","120113100":"天穆镇","120113101":"北仓镇","120113102":"双街镇","120113103":"双口镇","120113104":"青光镇","120113106":"宜兴埠镇","120113107":"小淀镇","120113108":"大张庄镇","120113111":"西堤头镇","120113400":"科技园区北区","120113401":"科技园区南区","120113402":"天津医药医疗器械工业园","120113403":"天津陆路港物流装备产业园","120113404":"天津风电产业园","120113500":"红旗农场","120113501":"曙光农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120113.json
// module id = 134
// module chunks = 0